/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AiOfferBatchRequest model module.
 * @module model/AiOfferBatchRequest
 * @version 1.0.0
 */
class AiOfferBatchRequest {
    /**
     * Constructs a new <code>AiOfferBatchRequest</code>.
     * @alias module:model/AiOfferBatchRequest
     * @param userIds {Array.<Number>} 生成対象のユーザー ID（1〜50 件）
     */
    constructor(userIds) { 
        
        AiOfferBatchRequest.initialize(this, userIds);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, userIds) { 
        obj['user_ids'] = userIds;
    }

    /**
     * Constructs a <code>AiOfferBatchRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AiOfferBatchRequest} obj Optional instance to populate.
     * @return {module:model/AiOfferBatchRequest} The populated <code>AiOfferBatchRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AiOfferBatchRequest();

            if (data.hasOwnProperty('user_ids')) {
                obj['user_ids'] = ApiClient.convertToType(data['user_ids'], ['Number']);
            }
            if (data.hasOwnProperty('re_proposal')) {
                obj['re_proposal'] = ApiClient.convertToType(data['re_proposal'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AiOfferBatchRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AiOfferBatchRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AiOfferBatchRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is an array
        if (!Array.isArray(data['user_ids'])) {
            throw new Error("Expected the field `user_ids` to be an array in the JSON data but got " + data['user_ids']);
        }

        return true;
    }


}

AiOfferBatchRequest.RequiredProperties = ["user_ids"];

/**
 * 生成対象のユーザー ID（1〜50 件）
 * @member {Array.<Number>} user_ids
 */
AiOfferBatchRequest.prototype['user_ids'] = undefined;

/**
 * 対象の母集団。false は未提案一覧（bulk_deliveries 相当）、 true は提案済み一覧（bulk_re_deliveries 相当）。
 * @member {Boolean} re_proposal
 * @default false
 */
AiOfferBatchRequest.prototype['re_proposal'] = false;






export default AiOfferBatchRequest;

